export const oauthConsent = {
  title: 'Authorize access',
  subtitle: 'wants to connect to your Referent account',
  genericClient: 'An application',
  loginPrompt: 'Sign in to continue authorizing the connection.',
  scopesTitle: 'This will allow the application to:',
  scopes: {
    'mcp:read': 'Read your organization content, plans and publications',
    'mcp:write': 'Create and update content and publications',
    offline_access: 'Stay connected without asking you to sign in again',
    openid: 'Verify your identity',
    profile: 'Access your basic profile information',
    email: 'Access your email address',
  },
  unknownScope: 'Access: {{scope}}',
  approve: 'Allow',
  reject: 'Deny',
  approving: 'Authorizing…',
  connectedAs: 'Signed in as {{email}}',
  missingCode: 'This authorization link is invalid or has expired. Start the connection again.',
  approveError: 'Could not complete authorization. Please try again.',
  rejected: 'Authorization denied.',
  emailRequired: 'Email is required',
  passwordRequired: 'Password is required',
  showPassword: 'Show password',
  hidePassword: 'Hide password',
} as const
